module.exports = {
    'environment': 'production',
    'apiUrl': "https://api.jibber.social",
};



// WEBPACK FOOTER //
// ./src/ENV.js